"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addGlobalPublishers = addGlobalPublishers;

var _typeGuards = require("@insided/shared/utils/typeGuards");

var _globals = require("@insided/shared/utils/globals");

function addGlobalPublishers() {
  document.querySelectorAll('[data-trigger]').forEach(function (element) {
    if (!(0, _typeGuards.isHtmlElement)(element)) return;
    element.addEventListener('click', function (e) {
      e.preventDefault();

      if (element.dataset.trigger === 'quote') {
        var _element$dataset$cont;

        if (!element.dataset.username) return;
        (0, _globals.publish)('quote', {
          username: element.dataset.username,
          content: (_element$dataset$cont = element.dataset.content) !== null && _element$dataset$cont !== void 0 ? _element$dataset$cont : ''
        });
      }
    });
  });
}